import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from 'lodash';
import qs from 'qs';

import { submitForm } from 'State/forms/actions';
import { DirtyWrapper, YesNoDialog } from 'Components';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { Filter, Main } from 'Containers';
import { LoadingPage } from 'Components/loading/LoadingPage';
import {
  APPLICATION_HUB_CONTACT_INFO_FORM_NAME,
  APPLICATION_HUB_APP_INFO_FORM_NAME,
} from 'Common/FormEnum';
import { getIsModified, urlParamObj } from 'Common/GeneralHelper';
import {
  toastSuccess,
  errorToast,
  createToast,
  toastType,
} from 'Common/ToastHelper';
import { ActiveStatusEnum } from 'Common/Constants/Enumeration/ActiveStatusEnum';
import { MonthEnum } from 'Common/Constants/Enumeration/MonthEnum';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { getId } from 'Common/Security/state/selectors';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as DialogActions from 'Components/dialogs/state/actions';
import { ExcludedVerificationStatuses } from 'Common/Constants/Enumeration/VerificationStatusEnum';
import * as CommonStateSelectors from 'State/selectors';
import * as ControlInfoSelectors from 'State/controlInfo/selectors';
import * as ControlInfoActions from 'State/controlInfo/actions';
import { removeFromQueryString } from 'Common/Helpers/querystring';

import * as ManageApplicationSelectors from '../state/manageapplication/selectors';
import * as ManageApplicationActions from '../state/manageapplication/actions';
import * as StudentLookupActions from '../state/studentlookup/actions';
import * as HubSelectors from '../state/hub/selectors';
import * as HubActions from '../state/hub/actions';
import {
  computedProps,
  noopSubmit,
  getEffectiveDatePickerProps,
  PAGE_REFS,
  QUERY_PARAMS,
} from '../helpers/hub';
import { VerificationStatusMessage } from '../helpers/Constants';
import {
  haveStudentsOrMemberCountsChanged,
  getCalculatedFamilySize,
  convertStudentForApplication,
} from '../helpers/Helpers';
import { DateDialog } from '../components/hub/DateDialog';
import {
  HubHeader,
  MemberTable,
  IncomeTable,
  ContactInfoForm,
  AppInformationForm,
} from '../components/';

import 'PageStyles/manageapplication/index.less';

class ApplicationHub extends Component {
  static path = '/manageapplication/:familyId';

  state = {
    showConfirmDateDialog: false,
    showEffectiveDateDialog: false,
    showVerificationExceptionDialog: false,
    student: null,
    fetchApp: () => {},
  };

  async componentDidMount() {
    const {
      dbApplication,
      fetchApplication,
      getUpdatedApplication,
      match: {
        params: { familyId },
      },
      shouldRecalculateApp,
      tempApplication,
      updateFamilySize,
      setIsSecondReview,
      setIsVerification,
      location,
      history: {
        location: { state },
      },
      autoPopulateStudentData,
      addStudentToApp,
      setAutoPopulateStudentData,
      shouldFetchControlInfo,
      getControlInfo,
      isDuplicateApp,
    } = this.props;
    const params = new URLSearchParams(location.search);

    if (params.has('secondReview')) {
      setIsSecondReview(Number(params.get('secondReview')) === 1);
    }

    if (params.has('verification')) {
      setIsVerification(Number(params.get('verification')) === 1);
    }

    const isFromReviewIncomingApp =
      params.has(QUERY_PARAMS.Ref) &&
      params.get(QUERY_PARAMS.Ref) === PAGE_REFS.ReviewIncomingApplication;

    if (!isFromReviewIncomingApp || !isDuplicateApp) {
      if (Object.keys(dbApplication).length === 0) {
        await fetchApplication(familyId);
      } else {
        if (state && state.isCopying && this.props.copyWarnings) {
          this.props.copyWarnings.forEach((warning) => {
            createToast(
              toastType.warning,
              warning.Title,
              warning.Message,
              false
            );
          });
        }

        if (shouldRecalculateApp) {
          getUpdatedApplication();
        } else {
          updateFamilySize(tempApplication);
        }
      }

      if (autoPopulateStudentData) {
        addStudentToApp(convertStudentForApplication(autoPopulateStudentData));
        setAutoPopulateStudentData(null);
      }

      this.setState({ fetchApp: () => fetchApplication(familyId) });
    } else {
      getUpdatedApplication();

      if (shouldFetchControlInfo) {
        getControlInfo();
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      tempApplication,
      appModifiedByUser,
      shouldRecalculateApp,
      fetching,
      userId,
      isSecondReview,
      isVerification,
      setIsSelectedForVerification,
      setVerificationSelectionLetterPrinted,
      verificationComplete,
      match: {
        params: { familyId },
      },
      reprocessSuccessful,
      setReprocessSuccessful,
      setHasReimbursableMeals,
      forceRecalculate,
      resetDirty,
      isDuplicateApp,
      verificationSelectionLetterPrinted,
      history,
      history: {
        location: { search, pathname },
      },
    } = this.props;

    const { r: redirect } = urlParamObj();

    const countsChanged = haveStudentsOrMemberCountsChanged(
      prevProps.tempApplication,
      tempApplication
    );
    const appUserId = !!tempApplication.ApplicationInformation
      ? tempApplication.ApplicationInformation.UserId
      : null;

    if (
      Object.keys(prevProps.tempApplication).length === 0 &&
      Object.keys(tempApplication).length > 0
    ) {
      const isSelected =
        tempApplication.ApplicationInformation &&
        !_.isNil(tempApplication.ApplicationInformation.VerificationStatus) &&
        tempApplication.ApplicationInformation.VerificationStatus !== '' &&
        !ExcludedVerificationStatuses.includes(
          tempApplication.ApplicationInformation.VerificationStatus
        );
      const verificationLetterPrinted =
        tempApplication.ApplicationInformation &&
        tempApplication.ApplicationInformation.VerificationSelectPrinted;

      setVerificationSelectionLetterPrinted(verificationLetterPrinted);

      setIsSelectedForVerification(isSelected);
      if (isSecondReview && userId === appUserId) {
        const hangtime = 8000;
        createToast(
          toastType.info,
          'The second review must be conducted by a user other than the user who processed the original application.',
          '',
          true,
          hangtime
        );
      }
      if (
        !isVerification &&
        isSelected &&
        !verificationComplete &&
        !isSecondReview
      ) {
        const hangtime = 8000;
        createToast(
          toastType.info,
          'Application has been selected for Verification. Changes must be done in the Selected for Verification tab',
          '',
          true,
          hangtime
        );
      }
      if (
        isSelected &&
        verificationComplete &&
        !isSecondReview &&
        !isVerification
      ) {
        createToast(
          toastType.warning,
          'WARNING',
          'Application has been completed for Verification. Changes made now may have adverse effects.',
          false
        );
      }
    }

    if (this.props.submitted && !prevProps.submitted) {
      toastSuccess('Application Saved');

      resetDirty();

      //TODO: May want to always just fetch the app, but won't always
      //need to replace on history; as changing the HoH last name
      //would not update when saving until the app was refetched
      if (familyId === '0') {
        const { FamilyNumber } = tempApplication.ApplicationInformation;

        this.getApp(FamilyNumber);
      }
    } else if (errorToast(this.props, prevProps, 'fetchError')) {
      if (this.props.shouldRedirect) {
        this.props.history.replace('/manageapplication');
      }
    } else if (errorToast(this.props, prevProps, 'submitErrors')) {
      this.props.clearErrors();
    }

    if (!prevProps.appRecalculated && this.props.appRecalculated) {
      this.props.setAppRecalculated(false);
    } else if (
      !fetching &&
      ((appModifiedByUser && countsChanged) || shouldRecalculateApp)
    ) {
      this.props.getUpdatedApplication();
    }

    if (this.props.shouldRedirect) {
      if (redirect === 'ria') {
        this.props.history.push(`/reviewincomingapplications`);
      } else if (
        tempApplication.ApplicationInformation &&
        !_.isNil(tempApplication.ApplicationInformation.VerificationStatus) &&
        tempApplication.ApplicationInformation.VerificationStatus !== ''
      ) {
        if (verificationSelectionLetterPrinted) {
          this.props.history.replace('/resultsinput');
        } else {
          this.props.history.replace('/confirmationreview');
        }
      } else {
        this.props.history.replace('/manageapplication');
      }
    }

    if (
      _.isNil(prevProps.reprocessSuccessful) &&
      !_.isNil(reprocessSuccessful)
    ) {
      const isSuccessful = reprocessSuccessful === '';

      createToast(
        isSuccessful ? toastType.success : toastType.info,
        'Success',
        isSuccessful ? 'Reprocessed Meals' : reprocessSuccessful
      );
      setReprocessSuccessful(null);
      setHasReimbursableMeals(false);
    }
    if (
      !!prevProps.tempApplication.ApplicationInformation &&
      prevProps.tempApplication.ApplicationInformation.FamilySize !==
        tempApplication.ApplicationInformation.FamilySize &&
      getCalculatedFamilySize(tempApplication) > 0
    ) {
      forceRecalculate();
    }

    // There is no duplicate app to pull in from the store if its a page refresh so remove
    // any related querystring parameters
    const currentQueryString = qs.parse(search);
    if (
      (currentQueryString[QUERY_PARAMS.Ref] ||
        currentQueryString[QUERY_PARAMS.IncomingAppId]) &&
      !isDuplicateApp
    ) {
      const queryString = removeFromQueryString(search, [
        QUERY_PARAMS.Ref,
        QUERY_PARAMS.IncomingAppId,
      ]);
      history.replace(`${pathname}${queryString}`);
    }
  }

  componentWillUnmount() {
    //remove toasts when leaving this page
    toast.dismiss();
  }

  getApp = (FamilyNumber) => {
    this.props.history.replace(`/manageapplication/${FamilyNumber}`);
    this.props.fetchApplication(FamilyNumber);

    this.setState({
      fetchApp: () => this.props.fetchApplication(FamilyNumber),
    });
  };

  getIncomingAppId = () => {
    const { history } = this.props;

    const queryString = _.get(history, 'location.search', '');
    const queryParams = qs.parse(queryString, {
      ignoreQueryPrefix: true,
    });

    return queryParams[QUERY_PARAMS.IncomingAppId];
  };

  onApplicationSaveClick = () => {
    toast.dismiss();

    const {
      submitForm,
      appInfoErrors,
      contactInfoErrors,
      tempApplication,
      isSecondReview,
      hasStatusChanged,
      setShowSecondReviewStatusChangeDialog,
      secondReviewResultRecorded,
      isSelectedForVerification,
    } = this.props;

    //Submit the forms just to ensure validation errors
    //are displayed. The check below will prevent saving
    //the application if there are any sync errors,
    //regardless if they are currently shown or not.
    submitForm(APPLICATION_HUB_CONTACT_INFO_FORM_NAME);
    submitForm(APPLICATION_HUB_APP_INFO_FORM_NAME);

    if (
      isSecondReview &&
      hasStatusChanged &&
      !secondReviewResultRecorded &&
      tempApplication.ApplicationInformation.SecondReviewResultId === null
    ) {
      setShowSecondReviewStatusChangeDialog(true);
    } else {
      if (
        Object.keys(contactInfoErrors).length > 0 ||
        Object.keys(appInfoErrors).length > 0
      ) {
        this.props.scrollMainTo(0, 1000);
      } else if (
        tempApplication.ApplicationInformation.VerificationStatus === 'X'
      ) {
        this.setState({ showVerificationExceptionDialog: true });
      } else if (isSelectedForVerification) {
        this.props.submitApplication();
      } else {
        this.setState({ showConfirmDateDialog: true });
      }
    }
  };

  onCancelApplicationSave = () => {
    const {
      setSecondReviewResultRecorded,
      resetSecondReviewResult,
    } = this.props;
    setSecondReviewResultRecorded(false);
    resetSecondReviewResult(Fields.SecondReviewCategoricalEligibilityError);
    resetSecondReviewResult(Fields.SecondReviewGrossIncomeCalculationError);
    resetSecondReviewResult(Fields.SecondReviewOtherError);
    this.setState({ showConfirmDateDialog: false });
  };

  onConfirmApplicationDate = () => {
    const { resetDirty } = this.props;

    this.setState({ showConfirmDateDialog: false });
    resetDirty();

    this.props.submitApplication(this.getIncomingAppId());
  };

  onChangeApplicationDateDuringEdit = (value) => {
    this.props.changeApplicationDate(value, true);
  };

  onChangeApplicationDateDuringSave = (value) => {
    this.props.changeApplicationDate(value, false);
  };

  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };

  onEffectiveDateClick = (student) => {
    this.setState({ student }, () => {
      this.setState({ showEffectiveDateDialog: true });
    });
  };

  onCloseChangeEffectiveDateDialog = () => {
    this.setState({ showEffectiveDateDialog: false });
  };

  onChangeEffectiveDate = (date) => {
    const { student } = this.state;

    if (student) {
      this.props.changeEffectiveDate(student[Fields.Id], date);
    }
  };

  getEffectiveDatePickerProps = () => {
    const { student } = this.state;

    const {
      applicationDate,
      dbApplication: { Students = [] },
      fiscalYear,
      isNewApp,
      preferences = [],
    } = this.props;

    const canSetPastEffectiveDate = !isPreferenceDisabled(
      PreferencesEnum.AllowPastEffectiveDate,
      preferences
    );

    let currentEffectiveDate = null;

    if (student) {
      const dbStudent = Students.find((s) => s.IdSeed === student.IdSeed) || {};
      currentEffectiveDate = dbStudent[Fields.EffectiveDate];
    }

    return getEffectiveDatePickerProps({
      student,
      isNewApp,
      applicationDate,
      fiscalYear,
      canSetPastEffectiveDate,
      currentEffectiveDate,
    });
  };

  get isReadOnly() {
    const { verificationComplete, isVerification } = this.props;
    return verificationComplete && isVerification;
  }

  getMainProps = () => {
    const {
      dbApplication,
      tempApplication,
      submitting,
      userId,
      isSecondReview,
      hasReimbursableMeals,
      reprocessingMealsLoading,
      setNotificationDialog,
      reprocessMealsModel,
      isVerification,
      isSelectedForVerification,
      verificationComplete,
      verificationSelectionLetterPrinted,
    } = this.props;
    const { url } = this.props.match;
    const { ApplicationInformation = {} } = tempApplication;
    const { ActiveStatus } = ApplicationInformation;
    const { r: redirect } = urlParamObj();

    const appUserId = !!dbApplication.ApplicationInformation
      ? dbApplication.ApplicationInformation.UserId
      : null;

    let backPath = this.getRootUrl();

    if (ActiveStatus === ActiveStatusEnum.Archived) {
      backPath = `${backPath}/?r=archived`;
    } else if (ActiveStatus === ActiveStatusEnum.Deleted) {
      backPath = `${backPath}/?r=deleted`;
    } else if (isVerification) {
      if (verificationSelectionLetterPrinted) {
        backPath = '/resultsinput';
      } else {
        backPath = '/confirmationreview';
      }
    } else if (isSecondReview) {
      backPath = `${backPath}/?r=secondReview`;
    }

    if (redirect === 'ria') {
      backPath = `${url.substring(
        0,
        url.lastIndexOf('manageapplication')
      )}reviewincomingapplications`;
    } else if (redirect) {
      backPath = redirect;
    } else if (this.getIncomingAppId()) {
      backPath = '/reviewincomingapplications';
    }

    return {
      toolbox: {
        backButtonProps: { shown: true, path: backPath },
        dirtyTracking: {
          ignoreEmptyStringToNull: true,
          modified: tempApplication,
          original: dbApplication,
        },
        rightButtons: [
          ...(hasReimbursableMeals && [
            {
              loading: reprocessingMealsLoading,
              disabled: reprocessingMealsLoading,
              content: 'Reprocess Meals',
              onClick: () => {
                setNotificationDialog({
                  ...NOTIFICATION_DIALOG_MESSAGES.APPLICATION_HUB_REPROCESS_MEALS,
                  actionsToDispatchOnOk: [
                    HubActions.checkClosedDates(reprocessMealsModel, 1),
                  ],
                });
              },
            },
          ]),
          {
            content: 'Save',
            loading: submitting,
            disabled:
              reprocessingMealsLoading ||
              submitting ||
              ActiveStatus !== ActiveStatusEnum.Active ||
              (userId === appUserId && isSecondReview) ||
              (!isVerification &&
                isSelectedForVerification &&
                !isSecondReview &&
                !verificationComplete) ||
              this.isReadOnly,
            onClick: this.onApplicationSaveClick,
          },
        ],
        shown: true,
      },
    };
  };

  getApplicationDatePickerProps = () => {
    const { fiscalYear } = this.props;

    const today = moment();
    const startOfFy = moment({
      year: fiscalYear - 1,
      month: MonthEnum.July,
      day: 1,
    });
    const endOfFy = moment({
      year: fiscalYear,
      month: MonthEnum.June,
      day: 30,
    });

    return {
      minDate: startOfFy.toDate(),
      maxDate: (endOfFy.isBefore(today) ? endOfFy : today).toDate(),
    };
  };

  getVerificationMessage(tempApplication) {
    if (
      tempApplication.ApplicationInformation &&
      !_.isNil(tempApplication.ApplicationInformation.VerificationStatus) &&
      tempApplication.ApplicationInformation.VerificationStatus !== ''
    ) {
      const { isSelectedForVerification } = this.props;
      if (isSelectedForVerification) {
        if (tempApplication.ApplicationInformation.VerificationStatus === 'X') {
          return 'Exempt From Verification';
        } else {
          return VerificationStatusMessage[
            tempApplication.ApplicationInformation.VerificationStatus
          ];
        }
      }
    }
  }

  render() {
    if (this.props.fetching) return <LoadingPage message={'loading'} />;

    const {
      appInfoInitialValues,
      appModifiedByUser,
      applicationDate,
      caseTypeLookup,
      deleteMember,
      deleteStudent,
      familySize,
      hadNote,
      hasHOH,
      history,
      hubHeaderInitialValues,
      incomeData,
      incomeString,
      incomeSummary,
      isNewApp,
      hasStudents,
      match: {
        params: { familyId },
      },
      memberData,
      releaseCategoryLookup,
      tempApplication,
      dbApplication,
      verificationComplete,
      userId,
      isSecondReview,
      isVerification,
      verificationSelectionLetterPrinted,
      setIsSecondReview,
      setSecondReviewResultRecorded,
      setShowSecondReviewStatusChangeDialog,
      isSelectedForVerification,
    } = this.props;

    const {
      showConfirmDateDialog,
      showEffectiveDateDialog,
      student,
      showVerificationExceptionDialog,
    } = this.state;

    var verificationMessage = this.getVerificationMessage(tempApplication);

    return (
      <Fragment>
        <Filter title={'Application Hub'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16} style={{ padding: '0px' }}>
                <DirtyWrapper
                  ignorePageLevelDirty={false}
                  closeModalYesCallback={() => {
                    if (isSecondReview) {
                      setIsSecondReview(false);
                    }
                    this.getApp(0);
                  }}
                  manual
                  original={dbApplication}
                  modified={tempApplication}
                >
                  {(showDirtyConfirm) => (
                    <Button
                      content="Add New Application"
                      floated="right"
                      disabled={isNewApp && !this.props.getPageLevelDirty()}
                      onClick={showDirtyConfirm}
                    />
                  )}
                </DirtyWrapper>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()}>
          <DateDialog
            buttonText={'Confirm Date'}
            datePickerProps={this.getApplicationDatePickerProps()}
            onCancel={this.onCancelApplicationSave}
            onChange={this.onChangeApplicationDateDuringSave}
            onComplete={this.onConfirmApplicationDate}
            open={showConfirmDateDialog}
            title={'Confirm Application Date'}
            value={applicationDate}
          />
          <DateDialog
            buttonText={'Set Date'}
            datePickerProps={this.getEffectiveDatePickerProps()}
            onCancel={this.onCloseChangeEffectiveDateDialog}
            onChange={this.onChangeEffectiveDate}
            onComplete={this.onCloseChangeEffectiveDateDialog}
            open={showEffectiveDateDialog}
            title={'Change Effective Date'}
            value={student ? student[Fields.EffectiveDate] : null}
          />
          <YesNoDialog
            showDialog={showVerificationExceptionDialog}
            title={'Exempt this application from verification?'}
            question={
              'The changes made to this application will make it exempt from verification. ' +
              'If saved, a new application will be selected for verification to replace this one. Continue?'
            }
            yesCallback={() => {
              this.setState(
                {
                  showVerificationExceptionDialog: false,
                },
                () => {
                  this.setState({
                    showConfirmDateDialog: true,
                  });
                }
              );
            }}
            noCallback={() => {
              this.setState({ showVerificationExceptionDialog: false });
            }}
          />
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <HubHeader
                  applicationDate={applicationDate}
                  applicationDatePickerProps={this.getApplicationDatePickerProps()}
                  appModifiedByUser={appModifiedByUser}
                  changeApplicationDate={this.onChangeApplicationDateDuringEdit}
                  fetchApp={this.state.fetchApp}
                  hasHOH={hasHOH}
                  history={history}
                  income={incomeString}
                  initialValues={hubHeaderInitialValues}
                  isNewApp={isNewApp}
                  hasStudents={hasStudents}
                  applicationData={tempApplication}
                  verificationMessage={verificationMessage}
                  verificationComplete={verificationComplete}
                  isVerification={isVerification}
                  userId={userId}
                  verificationSelectionLetterPrinted={
                    verificationSelectionLetterPrinted
                  }
                  appUserId={
                    !!dbApplication.ApplicationInformation
                      ? dbApplication.ApplicationInformation.UserId
                      : null
                  }
                  isSecondReview={isSecondReview}
                  setShowSecondReviewStatusChangeDialog={
                    setShowSecondReviewStatusChangeDialog
                  }
                  setSecondReviewResultRecorded={setSecondReviewResultRecorded}
                  onApplicationSaveClick={this.onApplicationSaveClick}
                  isSelectedForVerification={isSelectedForVerification}
                  isReadOnly={this.isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            {isVerification && (
              <Grid.Row>
                <Grid.Column className="manage-application--modify-note">
                  Use this screen to 'modify' your application if needed
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column>
                <MemberTable
                  caseTypeLookup={caseTypeLookup}
                  clearMarkAsNoChange={this.clearMarkAsNoChange}
                  deleteMember={deleteMember}
                  deleteStudent={deleteStudent}
                  familyId={familyId}
                  history={history}
                  memberData={memberData}
                  onEffectiveDateClick={this.onEffectiveDateClick}
                  isReadOnly={this.isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid.Row>
            <Grid.Column>
              <IncomeTable
                incomeData={incomeData}
                familyId={familyId}
                isReadOnly={this.isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <AppInformationForm
                familySize={familySize}
                hadNote={hadNote}
                incomeSummary={incomeSummary}
                initialValues={appInfoInitialValues}
                onSubmit={noopSubmit}
                releaseCategoryLookup={releaseCategoryLookup}
                tempApplication={tempApplication}
                isReadOnly={this.isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <ContactInfoForm
                initialValues={tempApplication.HouseholdContactInfo}
                onSubmit={noopSubmit}
                isReadOnly={this.isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    ManageApplicationState: { hub },
    CommonState: { controlInfo },
  } = state;

  const appModifiedByUser = getIsModified(
    hub.dbApplication,
    hub.tempApplication
  );

  ownProps.setPageLevelDirty(appModifiedByUser);
  const fetching = hub.fetching || ControlInfoSelectors.getFetching(state);

  return {
    ...hub,
    ...computedProps(state, ownProps),
    fetching,
    appModifiedByUser,
    dbApplication: hub.dbApplication,
    fiscalYear: CommonStateSelectors.getFiscalYear(state),
    preferences: state.SecurityState.preferences,
    verificationComplete: controlInfo.data.VerificationComplete,
    showSecondReviewStatusChangeDialog: hub.showSecondReviewStatusChangeDialog,
    userId: getId(state),
    setIsSecondReview: hub.isSecondReview,
    secondReviewResultRecorded: hub.secondReviewResultRecorded,
    hasReimbursableMeals: HubSelectors.getHasReimbursableMeals(state),
    reprocessMealsModel: HubSelectors.getReprocessMealsModel(state),
    reprocessingMealsLoading: HubSelectors.getReprocessingMealsLoading(state),
    reprocessSuccessful: HubSelectors.getReprocessSuccessful(state),
    isVerification: hub.isVerification,
    isSelectedForVerification: hub.isSelectedForVerification,
    verificationSelectionLetterPrinted: hub.verificationSelectionLetterPrinted,
    autoPopulateStudentData: ManageApplicationSelectors.getAutoPopulateStudentData(
      state
    ),
    caseTypeLookup: CommonStateSelectors.getCaseTypes(state),
    shouldFetchControlInfo: ControlInfoSelectors.getShouldFetchControlInfo(
      state
    ),
    isDuplicateApp: HubSelectors.getIsDuplicateApp(state),
  };
};

const mapDispatchToProps = {
  ...HubActions,
  submitForm,
  resetDirty,
  setNotificationDialog: DialogActions.setNotificationDialog,
  addStudentToApp: StudentLookupActions.addStudentToApp,
  setAutoPopulateStudentData:
    ManageApplicationActions.setAutoPopulateStudentData,
  getControlInfo: ControlInfoActions.getControlInfo,
};

ApplicationHub = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ApplicationHub)
);

export { ApplicationHub };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/ApplicationHub.js